import { Tabs } from '@/design-system';

import { ChartPeriod, ChartPeriodType } from '../../common';
import { PeriodTabs } from './performance-period-selector.styled';

interface PerformancePeriodSelectorProps {
  activePeriod: ChartPeriodType;
  onPeriodChange: (_period: ChartPeriodType) => void;
}

const PERIOD_LABELS: Record<ChartPeriodType, string> = {
  '1w': '1W',
  '1m': '1M',
  '1y': '1Y',
  all: 'All',
};

export const PerformancePeriodSelector = ({
  activePeriod,
  onPeriodChange,
}: PerformancePeriodSelectorProps) => (
  <PeriodTabs
    size="sm"
    variant="boxed"
    value={activePeriod}
    onValueChange={(value) => onPeriodChange(value as ChartPeriodType)}
  >
    <Tabs.List>
      {Object.values(ChartPeriod).map((period) => (
        <Tabs.Tab key={period} value={period} label={PERIOD_LABELS[period]} />
      ))}
    </Tabs.List>
  </PeriodTabs>
);
